import { render, staticRenderFns } from "./SettingsAutoPlayModal.vue?vue&type=template&id=5a956b11&scoped=true&"
import script from "./SettingsAutoPlayModal.vue?vue&type=script&lang=ts&"
export * from "./SettingsAutoPlayModal.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsAutoPlayModal.vue?vue&type=style&index=0&id=5a956b11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a956b11",
  null
  
)

export default component.exports